import { ArrowRight } from 'assets/icons';
import useHomeText from 'hooks/useHomeText';
import CallsRing from './CallsRing';

const TONES = {
  info: { card: 'bg-blue-50 hover:bg-[#e3edfd]', link: 'text-blue-700' },
  alert: { card: 'bg-red-50 hover:bg-red-100', link: 'text-red-700' },
};

/**
 * « Appels du jour », from `summary` (pages/home/homeItems `callsSummary`):
 * the calls to qualify first, in red; then no call planned, the list
 * finished, or what is left to call. The whole card leads where its link says
 * (`onNavigate` gets `prospection` or `recap`).
 */
const CallsCard = ({ summary, onNavigate }) => {
  const { text, plural } = useHomeText();
  let tone = TONES.info;
  let message;
  let link;
  if (summary.state === 'toQualify') {
    tone = TONES.alert;
    message = plural('calls.toQualify', summary.count);
    link = { label: text('calls.qualify'), target: 'prospection' };
  } else if (summary.state === 'none') {
    message = text('calls.none');
    link = { label: text('calls.prospectionMode'), target: 'prospection' };
  } else if (summary.state === 'finished') {
    message = text('calls.finished', { reached: summary.reached, booked: summary.booked });
    link = { label: text('calls.recap'), target: 'recap' };
  } else {
    message = `${plural('calls.left', summary.left)}${
      summary.late ? text('calls.late', { count: summary.late }) : ''
    }.${
      summary.next
        ? text('calls.next', {
            time: summary.next.time,
            name: summary.next.name || text('calls.someone'),
          })
        : ''
    }`;
    link = { label: text('calls.prospectionMode'), target: 'prospection' };
  }
  return (
    <button
      type="button"
      onClick={() => onNavigate(link.target)}
      className={`group flex min-h-[146px] w-full shrink-0 items-center gap-4 rounded-2xl p-4 text-left transition-colors ${tone.card}`}
    >
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-lg font-semibold leading-7 text-gray-900">{text('calls.title')}</span>
        <span className="text-sm leading-5 text-gray-700">{message}</span>
        <span
          className={`flex items-center gap-2.5 pt-0.5 text-sm font-medium underline-offset-4 group-hover:underline ${tone.link}`}
        >
          {link.label}
          <span className="flex transition-transform group-hover:translate-x-0.5">
            <ArrowRight wh={20} color="currentColor" />
          </span>
        </span>
      </span>
      <CallsRing done={summary.done} callbacks={summary.callbacks} total={summary.total} />
    </button>
  );
};

export default CallsCard;
